import { useCallback } from 'react';
import { applyGanalyticsTracking } from 'src/functions/propagateQueryParams';
import { safeNavigationHref } from 'src/functions/safeNavigationHref';
import { useExtraQueryParams } from './useExtraQueryParams';

export const appendExtraParams = (url: string, extraQueryParams: Record<string, string>): string => {
  if (!Object.keys(extraQueryParams).length || !url.includes('.mn.co')) {
    return url;
  }

  const extra = Object.entries(extraQueryParams)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  return url.includes('?') ? `${url}&${extra}` : `${url}?${extra}`;
};

const useExternalNavigation = (
  propExtraQueryParams?: Record<string, string>
): { navigateToExternal: (url: string) => void } => {
  const { extraQueryParams: contextExtraQueryParams } = useExtraQueryParams();

  const mergedParams = { ...contextExtraQueryParams, ...propExtraQueryParams };

  const navigateToExternal = useCallback(
    (url: string) => {
      const urlWithParams = appendExtraParams(url, mergedParams);
      const processedUrl = safeNavigationHref(urlWithParams);
      applyGanalyticsTracking(processedUrl)();
    },
    [mergedParams]
  );

  return { navigateToExternal };
};

export default useExternalNavigation;
